import React from 'react'
import ReactDOM from 'react-dom'
import { App } from './App'

export function startTranscriptDownloadMenu(data) {
  ReactDOM.render(<App transcripts={data['transcripts']} fileref={data['file_ref']} />, document.getElementById('transcript_menu_' + data['file_ref']))
}
